import isEqual from "lodash.isequal"
import { createActions, createReducer } from "reduxsauce"
import Immutable from "seamless-immutable"

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  getAlertsStatisticsRequest: ["payload"], // payload: { params }
  getAlertsStatisticsSuccess: ["payload"], // payload: { data }
  getAlertsStatisticsFailure: ["payload"], // payload: { data }

  getAlertsFilterOptionsRequest: ["payload"], // payload: { params }
  getAlertsFilterOptionsSuccess: ["payload"], // payload: { data }
  getAlertsFilterOptionsFailure: ["payload"], // payload: { data }

  getAlertsRequest: ["payload"], // payload: { params }
  getAlertsSuccess: ["payload"], // payload: { data }

  updateAlertRequest: ["payload"], // payload: { params }
  updateAlertSuccess: ["payload"], // payload: { newAlert }

  updateAlertFromDetailsPage: ["payload"], // { params }
  updateAlertTransactionRequest: ["payload"],
  updateAlertTransactionSuccess: ["payload"],
  updateAlertTransactionFailure: ["payload"],

  pinAlertRequest: ["payload"], // payload: { params }
  pinAlertSuccess: ["payload"], // payload: { newAlert }

  getAlertsOtherPageRequest: ["payload"], // payload: { params }
  getAlertsOtherPageSuccess: ["payload"], // payload: { data }
  alertsFailure: ["payload"], // payload: { errors }

  clearAlertsFilters: null,
  alertsSetProp: ["key", "value"],

  getAlertsExportRequest: ["payload"], // payload: { data }
  getAlertsExportSuccess: ["payload"], // payload: { url }
  getAlertsExportFailure: ["payload"], // payload: { errors }

  getAlertDetailsRequest: ["payload"], // payload: { alertID }
  getAlertDetailsSuccess: ["payload"], // payload: { alertDetails }
  getAlertDetailsFailure: ["payload"], // payload: { errors }

  getAlertLogsRequest: ["payload"], // payload: { alertID }
  getAlertLogsSuccess: ["payload"], // payload: { alertLogs }
  getAlertLogsFailure: ["payload"], // payload: { errors }

  getAlertDetailsExportRequest: ["payload"], // payload: { alertID }
  getAlertDetailsExportSuccess: null,
  getAlertDetailsExportFailure: ["payload"], // payload: { errors }

  createAlertTicketRequest: ["payload"], // payload: { data }
  createAlertTicketSuccess: null,
  createAlertTicketFailure: ["payload"], // payload: { errors }

  createCreditRequestRequest: ["payload"], // payload: { data }
  createCreditRequestSuccess: null,
  createCreditRequestFailure: ["payload"], // payload: { errors }

  alertsBulkResolveRequest: ["payload"], // payload: { data }
  alertsBulkResolveSuccess: ["payload"],
  alertsBulkResolveFailure: ["payload"], // payload: { errors }

  resetSaveResult: null,

  logout: null
})

export const AlertsTypes = Types
export default Creators

/* ------------- Initial State ------------- */

const columns = [
  { field_id: "transaction_id", label: "Transaction ID", active: true },
  { field_id: "alert_timestamp", label: "Alert date", active: true },
  { field_id: "transaction_timestamp", label: "Transaction date", active: true },
  { field_id: "alert_service", label: "Alert source", active: true },
  { field_id: "amount", label: "Order value", active: true },
  { field_id: "card_last4", label: "Card", active: true },
  { field_id: "country", label: "Country", active: true },
  { field_id: "bank_name", label: "Bank", active: true },
  { field_id: "alert_id", label: "Alert ID", active: true },
  { field_id: "arn", label: "ARN", active: true },
  { field_id: "auth_code", label: "Auth.Code", active: true },
  { field_id: "customer_email", label: "Customer email", active: true },
  { field_id: "customer_full_name", label: "Customer full name", active: true },
  { field_id: "alert_type", label: "Type", active: false },
  { field_id: "alert_reason", label: "Alert reason", active: false },
  { field_id: "merchant_descriptor", label: "Billing descriptor", active: false },
  { field_id: "payment_processor", label: "Payment processor", active: false },
  { field_id: "customer_unsubscribed", label: "Subscription canceled", active: false },
  { field_id: "original_alert_id", label: "Original alert", active: true }
]

const columnsAdmin = [
  { field_id: "user_full_name", label: "User full name", active: true },
  { field_id: "user_email", label: "User email", active: true },
  { field_id: "business_account", label: "Business account", active: true },
  { field_id: "business_url", label: "Business URL", active: true },
  { field_id: "merchant_descriptor", label: "Billing descriptor", active: true },
  { field_id: "alert_type", label: "Type", active: true },
  { field_id: "alert_reason", label: "Alert reason", active: true },
  { field_id: "transaction_timestamp", label: "Transaction date", active: true },
  { field_id: "alert_timestamp", label: "Alert date", active: true },
  { field_id: "alert_service", label: "Alert source", active: true },
  { field_id: "amount", label: "Order value", active: true },
  { field_id: "country", label: "Country", active: true },
  { field_id: "bank_name", label: "Bank", active: true },
  { field_id: "card_last4", label: "Card", active: true },
  { field_id: "payment_processor", label: "Payment processor", active: true },
  { field_id: "customer_email", label: "Customer email", active: true },
  { field_id: "customer_full_name", label: "Customer full name", active: true },
  { field_id: "alert_id", label: "Alert ID", active: true },
  { field_id: "transaction_id", label: "Transaction ID", active: true },
  { field_id: "arn", label: "ARN", active: true },
  { field_id: "auth_code", label: "Auth.Code", active: true },
  { field_id: "customer_unsubscribed", label: "Subscription canceled", active: true },
  { field_id: "user_visibility", label: "User visibility", active: true },
  { field_id: "paid_status", label: "Paid status", active: true },
  { field_id: "status_set", label: "Status set", active: true },
  { field_id: "credit_request_type", label: "Credit request", active: true },
  { field_id: "original_alert_id", label: "Original alert", active: true },
  { field_id: "billing_descriptor_status", label: "Descriptor status", active: true }
]

export const INITIAL_STATE = Immutable({
  fetchingStatistics: false,
  statistics: {
    all: 0,
    ethoca: 0,
    cdrn: 0,
    rdr: 0
  },
  fetching: false,
  result: {
    count: 0,
    next: null,
    previous: null,
    results: [],
    attention_list: [],
    statistics: {
      all: 0,
      ethoca: 0,
      cdrn: 0,
      rdr: 0,
      attentions: 0
    }
  },
  defaultColumns: [{ field_id: "alert_status", label: "Status" }, ...columns],
  columns: [...columns],

  defaultColumnsAdmin: [{ field_id: "alert_status", label: "Status" }, ...columnsAdmin],
  columnsAdmin: [...columnsAdmin],

  filtersLastUpd: null,
  filters: {
    alert_timestamp: null,
    transaction_timestamp: null,
    alert_status: "all",
    alert_type: "all",
    alert_reason: "all",
    alert_service: "all",

    user_full_name: [],
    user_email: [],
    customer_email: [],
    customer_full_name: [],
    business_account: [],
    business_url: [],

    amount: { min: null, max: null, type: null },
    bank_name: "all",
    merchant_descriptor: "all",
    country: "all",
    payment_processor: "all",
    alert_id: [],
    transaction_id: [],
    arn: [],
    auth_code: [],
    card_last4: [],
    customer_unsubscribed: "all",
    exclude_fields: [],
    user_visibility: "all",
    paid_status: "all"
  },

  fetchingFilterOptions: false,
  filterOptions: {
    alert_status: [],
    alert_type: [],
    alert_reason: [],
    country: [],
    bank_name: [],
    payment_processor: [],
    customer_unsubscribed: [],
    paid_status: []
  },

  visibleFilters: {
    alert_status: true,
    transaction_id: true,
    alert_timestamp: true,
    alert_service: true,
    card_last4: true
  },
  visibleFiltersAdmin: {
    alert_status: true,
    user_email: true,
    business_account: true,
    alert_timestamp: true
  },

  exportFetching: false,
  exportResult: null,

  saveFetching: false,
  creditRequestSubmitting: false,
  saveResult: null,
  transactionModalSaving: false,
  transactionModalError: null,

  alertDetailsFetching: false,
  alertDetails: null,

  alertLogsFetching: false,
  alertLogs: [],

  alertsViewMode: "table"
})

/* ------------- Selectors ------------- */
export const selectAreFiltersDefault = (state) =>
  isEqual(state.alerts.filters, INITIAL_STATE.filters)

/* ------------- Functions for reducer cases ------------- */
const getAlertsStatisticsRequest = (state) => state.merge({ fetchingStatistics: true })
const getAlertsStatisticsSuccess = (state, { payload: statistics }) =>
  state.merge({ fetchingStatistics: false, statistics })
const getAlertsStatisticsFailure = (state) => state.merge({ fetchingStatistics: false })

const getAlertsFilterOptionsRequest = (state) => state.merge({ fetchingFilterOptions: true })
const getAlertsFilterOptionsSuccess = (state, { payload: filterOptions }) =>
  state.merge({ fetchingFilterOptions: false, filterOptions })
const getAlertsFilterOptionsFailure = (state) => state.merge({ fetchingFilterOptions: false })

const getAlertsRequest = (state) => state.merge({ fetching: true })
const getAlertsSuccess = (state, { payload: result }) => state.merge({ fetching: false, result })
const getAlertsOtherPageRequest = (state) => state.merge({ fetching: true })
const getAlertsOtherPageSuccess = (state, { payload: result }) =>
  state.merge({ fetching: false, result })
const alertsFailure = (state) => state.merge({ fetching: false })

const updateAlertRequest = (state) => state.merge({ fetching: true })
const updateAlertSuccess = (state, { payload: alert }) => {
  //let newResults = state.result.results?.map(el => el.id === alert.id ? alert : el)
  let newResults = state.result.results?.map((el) =>
    el.alert_id === alert.alert_id ? { ...el, ...alert } : el
  )
  let newAttentionList = state.result.attention_list
    ? state.result.attention_list.filter((id) => id !== alert.alert_id)
    : []

  return state.merge({
    fetching: false,
    result: {
      ...state.result,
      attention_list: newAttentionList,
      results: newResults
    },
    saveResult: "alert_update"
  })
}

const updateAlertFromDetailsPage = (state) => state.merge({ fetching: true })

const updateAlertTransactionRequest = (state) =>
  state.merge({
    transactionModalSaving: true,
    transactionModalError: null
  })

const updateAlertTransactionSuccess = (state, { payload: alert }) => {
  const newResults = state.result.results?.map((el) =>
    el.alert_id === alert.alert_id ? { ...el, ...alert } : el
  )

  return state.merge({
    transactionModalSaving: false,
    transactionModalError: null,
    result: {
      ...state.result,
      results: newResults
    },
    alertDetails:
      state.alertDetails?.alert_id === alert.alert_id
        ? {
            ...state.alertDetails,
            ...alert
          }
        : state.alertDetails,
    saveResult: "alert_transaction_update"
  })
}

const updateAlertTransactionFailure = (state, { payload: error }) =>
  state.merge({
    transactionModalSaving: false,
    transactionModalError: error
  })

const pinAlertRequest = (state) => state.merge({ fetching: true })
const pinAlertSuccess = (state) => {
  return state.merge({
    fetching: false,
    saveResult: "pin"
  })
}

export const alertsSetProp = (state, { key, value }) => {
  const obj = {}
  if (["filters", "visibleFilters", "visibleFiltersAdmin"]?.includes(key)) {
    if (key === "filters") obj.filtersLastUpd = new Date().getTime()
    obj[key] = { ...state?.[key], ...value }
  } else {
    obj[key] = value
  }
  return state.merge(obj)
}

export const clearAlertsFilters = (state) => {
  return state.merge({ filters: INITIAL_STATE.filters })
}

const getAlertsExportRequest = (state) => state.merge({ exportFetching: true })
const getAlertsExportSuccess = (state, { payload: exportResult }) =>
  state.merge({
    exportFetching: false,
    exportResult
  })
const getAlertsExportFailure = (state) => state.merge({ exportFetching: false })

const getAlertDetailsRequest = (state) => state.merge({ alertDetailsFetching: true })
const getAlertDetailsSuccess = (state, { payload: alertDetails }) =>
  state.merge({
    alertDetailsFetching: false,
    alertDetails
  })
const getAlertDetailsFailure = (state) => state.merge({ alertDetailsFetching: false })

const getAlertLogsRequest = (state) => state.merge({ alertLogsFetching: true })
const getAlertLogsSuccess = (state, { payload: alertLogs }) =>
  state.merge({
    alertLogsFetching: false,
    alertLogs
  })
const getAlertLogsFailure = (state) => state.merge({ alertLogsFetching: false })

const getAlertDetailsExportRequest = (state) => state.merge({ saveFetching: true })
const getAlertDetailsExportSuccess = (state) =>
  state.merge({
    saveFetching: false,
    saveResult: "alert_details_export"
  })
const getAlertDetailsExportFailure = (state) => state.merge({ saveFetching: false })

const createAlertTicketRequest = (state) => state.merge({ saveFetching: true })
const createAlertTicketSuccess = (state, { payload: data }) =>
  state.merge({
    saveFetching: false,
    saveResult: "ticket_create",
    alertDetails: {
      ...state.alertDetails,
      ...data
    }
  })
const createAlertTicketFailure = (state) => state.merge({ saveFetching: false })

const createCreditRequestRequest = (state) =>
  state.merge({ saveFetching: true, creditRequestSubmitting: true })
const createCreditRequestSuccess = (state, { payload: data }) =>
  state.merge({
    saveFetching: false,
    creditRequestSubmitting: false,
    saveResult: "credit_request_create"
  })
const createCreditRequestFailure = (state) =>
  state.merge({ saveFetching: false, creditRequestSubmitting: false })

const alertsBulkResolveRequest = (state) => state.merge({})
const alertsBulkResolveSuccess = (state, { payload: data }) => state.merge({})
const alertsBulkResolveFailure = (state) => state.merge({})

const resetSaveResult = (state) => state.merge({ saveResult: null })

const logout = (state) => {
  return state.merge({
    ...INITIAL_STATE
  })
}

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_ALERTS_STATISTICS_REQUEST]: getAlertsStatisticsRequest,
  [Types.GET_ALERTS_STATISTICS_SUCCESS]: getAlertsStatisticsSuccess,
  [Types.GET_ALERTS_STATISTICS_FAILURE]: getAlertsStatisticsFailure,

  [Types.GET_ALERTS_FILTER_OPTIONS_REQUEST]: getAlertsFilterOptionsRequest,
  [Types.GET_ALERTS_FILTER_OPTIONS_SUCCESS]: getAlertsFilterOptionsSuccess,
  [Types.GET_ALERTS_FILTER_OPTIONS_FAILURE]: getAlertsFilterOptionsFailure,

  [Types.GET_ALERTS_REQUEST]: getAlertsRequest,
  [Types.GET_ALERTS_SUCCESS]: getAlertsSuccess,

  [Types.UPDATE_ALERT_REQUEST]: updateAlertRequest,
  [Types.UPDATE_ALERT_SUCCESS]: updateAlertSuccess,

  [Types.UPDATE_ALERT_FROM_DETAILS_PAGE]: updateAlertFromDetailsPage,
  [Types.UPDATE_ALERT_TRANSACTION_REQUEST]: updateAlertTransactionRequest,
  [Types.UPDATE_ALERT_TRANSACTION_SUCCESS]: updateAlertTransactionSuccess,
  [Types.UPDATE_ALERT_TRANSACTION_FAILURE]: updateAlertTransactionFailure,

  [Types.PIN_ALERT_REQUEST]: pinAlertRequest,
  [Types.PIN_ALERT_SUCCESS]: pinAlertSuccess,

  [Types.GET_ALERTS_OTHER_PAGE_REQUEST]: getAlertsOtherPageRequest,
  [Types.GET_ALERTS_OTHER_PAGE_SUCCESS]: getAlertsOtherPageSuccess,

  [Types.ALERTS_FAILURE]: alertsFailure,

  [Types.CLEAR_ALERTS_FILTERS]: clearAlertsFilters,

  [Types.ALERTS_SET_PROP]: alertsSetProp,

  [Types.GET_ALERTS_EXPORT_REQUEST]: getAlertsExportRequest,
  [Types.GET_ALERTS_EXPORT_SUCCESS]: getAlertsExportSuccess,
  [Types.GET_ALERTS_EXPORT_FAILURE]: getAlertsExportFailure,

  [Types.GET_ALERT_DETAILS_REQUEST]: getAlertDetailsRequest,
  [Types.GET_ALERT_DETAILS_SUCCESS]: getAlertDetailsSuccess,
  [Types.GET_ALERT_DETAILS_FAILURE]: getAlertDetailsFailure,

  [Types.GET_ALERT_LOGS_REQUEST]: getAlertLogsRequest,
  [Types.GET_ALERT_LOGS_SUCCESS]: getAlertLogsSuccess,
  [Types.GET_ALERT_LOGS_FAILURE]: getAlertLogsFailure,

  [Types.GET_ALERT_DETAILS_EXPORT_REQUEST]: getAlertDetailsExportRequest,
  [Types.GET_ALERT_DETAILS_EXPORT_SUCCESS]: getAlertDetailsExportSuccess,
  [Types.GET_ALERT_DETAILS_EXPORT_FAILURE]: getAlertDetailsExportFailure,

  [Types.CREATE_ALERT_TICKET_REQUEST]: createAlertTicketRequest,
  [Types.CREATE_ALERT_TICKET_SUCCESS]: createAlertTicketSuccess,
  [Types.CREATE_ALERT_TICKET_FAILURE]: createAlertTicketFailure,

  [Types.CREATE_CREDIT_REQUEST_REQUEST]: createCreditRequestRequest,
  [Types.CREATE_CREDIT_REQUEST_SUCCESS]: createCreditRequestSuccess,
  [Types.CREATE_CREDIT_REQUEST_FAILURE]: createCreditRequestFailure,

  [Types.ALERTS_BULK_RESOLVE_REQUEST]: alertsBulkResolveRequest,
  [Types.ALERTS_BULK_RESOLVE_SUCCESS]: alertsBulkResolveSuccess,
  [Types.ALERTS_BULK_RESOLVE_FAILURE]: alertsBulkResolveFailure,

  [Types.RESET_SAVE_RESULT]: resetSaveResult,

  [Types.LOGOUT]: logout
})
